module.exports = __webpack_public_path__ + "static/media/green-checkmark.e457bc8f.svg";